import { Menu, Dropdown, Icon, Row, Col } from 'antd';
import styled from 'styled-components';
import _ from 'lodash';
import React, { Component } from 'react';
import { GRAY_LIGHT } from '../../views/styleConstants';
import Button from '../../views/StyledButton';
import Ellipsed from '../../views/Ellipsed';
import './queryTab.css';

const Root = styled.div`
  display: inline-block;
  border: 1px solid ${GRAY_LIGHT};
  padding: 2px;
`;

const AddFieldButton = styled.div`
  
`;

const DisabledButton = styled.div`
    background-color: #e2e2e2;
    border: 1px solid #e8e6e6;
    width: 80px;
    border-radius: 5px;
    color: #c5c2c2;
    cursor: not-allowed;
`;

export default class SchemaMenu extends Component {
  constructor(props) {
    super(props);

    const { root } = props;
    this.state = { root };
    this.onClick = this.onClick.bind(this);
  }

  onClick(event, item, advanced, desc) {
    if (this.props.onClick) {
      setTimeout(() => {
        this.props.onClick(item, advanced, desc);
      }, 10);
    }
  }

  basicLink(item, span, desc, advanced = false) {
    if (desc) {
      return (
        <Col span={span}>
          <Button
            size="small"
            type="default"
            onClick={event => this.onClick(event, item, advanced, desc)}
            icon="sort-descending"
          >DESC
          </Button>
        </Col>
      );
    }
    return (
      <Col onClick={event => this.onClick(event, item, advanced)} span={span}>
        <Ellipsed
          width={span * 20}
        ><b>{item.toString()}</b>
        </Ellipsed>
      </Col>
    );
  }

  menuSubItem(item) {
    if (this.props.type === 'order') {
      return [
        <Menu.Item key={item.name}>
          <Row>
            {this.basicLink(item, 18)}
            {this.basicLink(item, 6, true)}
          </Row>
        </Menu.Item>,
      ];
    }
    if (!(this.props.type !== 'where')) {
      return (
        <Menu.Item key={item.name}>
          <Row>
            <Col onClick={event => this.onClick(event, item, true)} span={6}>{item.type}:</Col>
            {this.basicLink(item, 14, false, true)}
          </Row>
        </Menu.Item>
      );
    }
    return (
      <Menu.Item key={item.name}>
        <Row>
          <Col onClick={event => this.onClick(event, item)} span={6}>{item.type}:</Col>
          {this.basicLink(item, 14)}
          <Col onClick={event => this.onClick(event, item, true)} span={2}>
            <Icon
              theme="info"
              filled
              type="info-circle"
            />
          </Col>
        </Row>
      </Menu.Item>
    );
  }

  menuItem(ss) {
    if (ss.name === 'metadata') {
      return (
        <Menu.SubMenu key="metadata" title="Metadata">
          <Menu.Item onClick={(event) => {
            console.log('clicked on metadata', ss);
            this.onClick(event, ss);
          }}
          >
            <b>metadata (object)</b>
          </Menu.Item>
        </Menu.SubMenu>);
    }
    const items = Array.from(ss.members.values());
    return (
      <Menu.SubMenu key={ss.name} title={ss.name} className="limit-antd-menu-height"
                    popupClassName="ant-dropdown-menu-clamped">
        {_(items)
          .sortBy('name')
          .map(item => this.menuSubItem(item))
          .flatten()
          .value()}
      </Menu.SubMenu>
    );
  }

  render() {
    const { type, root } = this.props;

    if (!root) {
      return <DisabledButton>
        <span className="add-field-plus">+</span>{type === 'where' ? 'Filter' : 'Field'}
      </DisabledButton>;
    }

    const schemaItem = Array.from(root.members.values());
    return (<Dropdown overlay={(
        <Menu mode="vertical">
          {schemaItem.map(subItem => this.menuItem(subItem))}
        </Menu>
      )}
      >
        <Root data-react-id="root">
          <AddFieldButton>
            <span className="add-field-plus">+</span>{type === 'where' ? 'Filter' : 'Field'}
          </AddFieldButton>
        </Root>
      </Dropdown>
    );
  }
}
